var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ecommerce copia 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 31,
    r: 13,
    fill: "#e1f6fa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98,65V81H89a6,6,0,0,0-12,0H70V48H87Zm-7,0L85,55H77V65H91Z",
    fill: "#9ae3f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75,82H14a1,1,0,0,1-1-1V31a1,1,0,0,1,1-1H24v2H15V80h8.75v2Z",
    fill: "#495771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,88a7,7,0,1,1,7-7A7,7,0,0,1,30,88Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,30,76Z",
    fill: "#495771"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42,50A19,19,0,1,1,61,31,19,19,0,0,1,42,50Zm0-36A17,17,0,1,0,59,31,17,17,0,0,0,42,14Z",
    fill: "#495771"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 57,
    width: 16,
    height: 2,
    fill: "#495771"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80,
    width: 7,
    height: 2,
    fill: "#495771"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98,82H89V80h8V65.29L86.46,49H70V47H87a1,1,0,0,1,.84.46l11,17A1,1,0,0,1,99,65V81A1,1,0,0,1,98,82Z",
    fill: "#495771"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70,82H36.25V80H69V32H60V30H70a1,1,0,0,1,1,1V81A1,1,0,0,1,70,82Z",
    fill: "#495771"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83,88a7,7,0,1,1,7-7A7,7,0,0,1,83,88Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,83,76Z",
    fill: "#495771"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91,66H77a1,1,0,0,1-1-1V55a1,1,0,0,1,1-1h8a1,1,0,0,1,.86.49l6,10A1,1,0,0,1,91,66ZM78,64H89.23l-4.8-8H78v8Z",
    fill: "#495771"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48,32.52H42a1,1,0,0,1-1-1v-9h2v8h5v2Z",
    fill: "#495771"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 47,
    width: 20,
    height: 2,
    fill: "#495771"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 37,
    width: 16,
    height: 2,
    fill: "#495771"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.d26880231f8405ce848bb22c6197e486.svg";
export { ForwardRef as ReactComponent };